import React from 'react';
import LazyLoadingList from 'components/@common/ListUtilities/LazyLoadingList';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { ActionOption } from 'types';
import { User } from 'types/schema-generated-types';
import UserCard from './UserCard';

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      display: 'grid',
      gridGap: theme.spacing(4),
      gridTemplateColumns: `repeat(auto-fill, minmax(300px, 1fr))`,
      gridAutoFlow: 'dense',
      padding: theme.spacing(4)
    }
  };
});

export interface TileViewContainerProps {
  users: User[];
  actionOptions?: ActionOption[];
}

const TileViewContainer: React.FC<TileViewContainerProps> = ({ users, actionOptions }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <LazyLoadingList
        data={users}
        limit={50}
        renderItem={({ index, item }) => (
          <UserCard key={`user_${item.id}`} user={item} actionOptions={actionOptions} />
        )}
      />
    </div>
  );
};

export default TileViewContainer;
